/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Response containing the PEM-encoded public key for a given VMUA key pair.
 */
export interface VmuaPublicKeyResponse { 
    /**
     * The key identifier.
     */
    keyId?: string;
    /**
     * PEM-encoded RSA public key (X.509 / SubjectPublicKeyInfo format). Share this with SnapService so they can encrypt VMUA requests.
     */
    publicKeyPem?: string;
}

